import { render, staticRenderFns } from "./TabReporteGeneral.vue?vue&type=template&id=3a33edf6&"
import script from "./TabReporteGeneral.vue?vue&type=script&lang=js&"
export * from "./TabReporteGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports